import axios from 'axios';
import './App.css';
import { MortgageApplication } from './pages/MortgageApplication.tsx';
import { steps } from './helpers/Lists.js';
import { Toaster } from 'react-hot-toast';

function App(props) {
  var gtmTag = process.env.REACT_APP_GTM_TAG ?? '';
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;

  var showCalculators = false;
  if (window.location.host.startsWith("local")) {
    showCalculators = true;
  }

  var step = '';
  var journey = '';

  if (props.startAt) {
    var startAt = props.startAt.split(',');
    step = startAt[0];
    if (startAt.length > 1) {
      journey = startAt[1];
    }
  } else {
    step = steps.buyorswitch;
  }
  return (
    <div className="App">
      <Toaster />
      <MortgageApplication gtmTag={gtmTag} showCalculators={showCalculators} startingStep={step} journey={journey} />
    </div>
  );
}

export default App;
